import InfoMessageBlock from './InfoMessageBlock.jsx';
import useBusinessNavigate from '../lib/useBusinessNavigate.js';
import { InformationCircleIcon } from '@heroicons/react/24/outline/index.js';
import { useBusinessInfo } from '../lib/Queries';

/**
 * Show a feature gate to free users
 *
 * @param children
 * @param className
 * @constructor
 */
const FeatureGateMessage = ({ children, className }) => {
    const navigate = useBusinessNavigate();
    const { data } = useBusinessInfo();

    if (!data || data?.business?.plan !== 'free') {
        return;
    }

    return (
        <InfoMessageBlock className={className} showIcon={true}>
            <div className="">
                <div>{children}</div>

                <div className="mt-2">
                    <button
                        type="button"
                        className="px-4 py-2 hover:bg-primary-700 hover:text-primary-100 rounded-full border border-primary-700"
                        onClick={() => navigate('/settings/billing')}
                    >
                        Upgrade Now
                    </button>
                </div>
            </div>
        </InfoMessageBlock>
    );
};

export default FeatureGateMessage;
